export default "__VITE_ASSET__DytOsk9$__"